// Das farbige Band mit dem Kennzeichen-Buchstaben: Euro-Band mit
// Sternenkranz fuer EU-Laender (flagStyle "euro"), sonst ein neutrales
// Feld mit nur dem Buchstaben - fuer Laender ohne flagStyle "euro" fehlt
// bislang eine echte Flaggengrafik (siehe docs/decisions.md E9, E26, E27).
//
// Gemeinsam genutzt von KennzeichenGrafik.tsx (grosse Fassung beim
// Suchen) und Drawer.tsx (kleines Abzeichen in der Laenderliste,
// IMG-Referenz 01.09.2026: auch dort ein sichtbarer Sternenkranz bei
// EU-Laendern, nicht nur der Buchstabe) - eine spaetere echte Flagge fuer
// ein Land wird dadurch nur an einer Stelle ergaenzt.

import type { Land } from "../lib/bundle.js";

// Fuenfzack-Pfad, ein Punkt zeigt nach oben (0 Grad = 12 Uhr), wie im
// Original (IMG_4893: alle zwoelf Sterne gleich ausgerichtet, nicht
// radial zum Kreismittelpunkt gedreht).
function sternPfad(cx: number, cy: number, aussenR: number, innenR: number) {
  const punkte = Array.from({ length: 10 }, (_, i) => {
    const r = i % 2 === 0 ? aussenR : innenR;
    const winkel = (i / 10) * 2 * Math.PI - Math.PI / 2;
    return `${(cx + r * Math.cos(winkel)).toFixed(2)},${(cy + r * Math.sin(winkel)).toFixed(2)}`;
  });
  return `M${punkte.join("L")}Z`;
}

/**
 * Unter ~18px verschwimmen die duennen Fuenfzack-Spitzen beim Skalieren zu
 * einem ungleichmaessigen Fleck statt eines sauberen Kreises (Referenz-
 * Screenshot 01.09.2026, kleines Laender-Abzeichen im Drawer) - dort reichen
 * einfache Punkte, genau wie sie im Original bei dieser Groesse ohnehin
 * kaum von echten Sternspitzen zu unterscheiden waeren.
 */
export function Sternenkranz({ groesse = 24 }: { groesse?: number }) {
  const vereinfacht = groesse < 18;
  const positionen = Array.from({ length: 12 }, (_, i) => {
    const winkel = (i / 12) * 2 * Math.PI - Math.PI / 2;
    return { x: 12 + 8 * Math.cos(winkel), y: 12 + 8 * Math.sin(winkel) };
  });
  return (
    <svg viewBox="0 0 24 24" style={{ width: groesse, height: groesse }}>
      {positionen.map((p, i) =>
        vereinfacht ? (
          <circle key={i} cx={p.x} cy={p.y} r={1.2} fill="#FFCC00" />
        ) : (
          <path key={i} d={sternPfad(p.x, p.y, 1.7, 0.65)} fill="#FFCC00" />
        ),
      )}
    </svg>
  );
}

export function Flaggenband({
  land,
  breite,
  hoehe,
  sternGroesse,
  schriftKlasse,
  gerundet = false,
}: {
  land: Land | undefined;
  breite: number;
  hoehe: number;
  sternGroesse: number;
  schriftKlasse: string;
  /** Fuer freistehende Abzeichen (Drawer). Die grosse Grafik rundet ueber ihren Rahmen, nicht das Band selbst. */
  gerundet?: boolean;
}) {
  const euro = !land || land.flagStyle === "euro";
  return (
    <div
      className={`flex shrink-0 flex-col items-center justify-center gap-0.5 overflow-hidden ${gerundet ? "rounded-sm" : ""}`}
      style={{ width: breite, height: hoehe, backgroundColor: euro ? "#003399" : "#424242" }}
    >
      {euro && <Sternenkranz groesse={sternGroesse} />}
      {land && <span className={`font-bold text-white ${schriftKlasse}`}>{land.plateLetter}</span>}
    </div>
  );
}
